import type {ModelFilterTechnicalDataGroup} from '@volkswagen-onehub/car-technical-details-bff';
import * as React from 'react';
import {mergeTechnicalDataWithSameKey} from './mergeTechnicalDataWithSameKey';
import {MultiTableWithFilter} from './multi-table/multiTableWithFilter';
import {Table} from './table';
import {useFeatureServices} from '../use-feature-services';
import {useTranslate} from '../utils/translate';

export const TechnicalDataSectionContent = (props: {
  group: ModelFilterTechnicalDataGroup;
}): JSX.Element | null => {
  const {group} = props;
  const translate = useTranslate();
  const logger = useFeatureServices()['s2:logger'];

  if (group.variations.length === 1) {
    const uniqueTechnicalData = mergeTechnicalDataWithSameKey(
      group.variations[0].values,
      translate,
    );
    return (
      <Table
        values={uniqueTechnicalData}
        tableTitle={group.name}
        groupKey={group.key}
      />
    );
  }

  if (group.discriminatingModelFilterTypes.length == 0) {
    logger?.warn('unknown case');
    return null;
  }

  return <MultiTableWithFilter group={group} />;
};
